import { render } from "./SurveyErrorText.vue?vue&type=template&id=a70690a8&ts=true"
import script from "./SurveyErrorText.vue?vue&type=script&lang=ts"
export * from "./SurveyErrorText.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__